<template>
  <div class="content">
    <section class="top-img">
      <img :src="$common.getResourceUrl('pcweb/children/banner2.jpg')" />
    </section>
    <section class="box fff">
      <div class="common-title">
        <div class="headTitle">
          <div class="imgIcon r"></div>
          <div class="title">&nbsp;孩子学画画，为什么选择「小白美术」</div>
          <div class="imgIcon l"></div>
        </div>
        <div class="smTitle">
          为8-12岁孩子提供系统性数字美术课，遵从孩子的天性，以提升孩子的兴趣
          知识百科、专注力为先导，让孩子用新的画画方式认识世界。
        </div>
      </div>
      <div class="box1-img commonStyle">
        <div class="childrenImg">
          <img :src="$common.getResourceUrl('pcweb/children/img_b1.jpg')" />
          <span>全新数字绘画课</span>
        </div>
        <div class="childrenImg">
          <img :src="$common.getResourceUrl('pcweb/children/img_b2.jpg')" />
          <span>培养创作思维</span>
        </div>
        <div class="childrenImg">
          <img :src="$common.getResourceUrl('pcweb/children/img_b3.jpg')" />
          <span>提升学习能力</span>
        </div>
        <div class="childrenImg">
          <img :src="$common.getResourceUrl('pcweb/children/img_b4.jpg')" />
          <span>开拓认知视野</span>
        </div>
      </div>
    </section>
    <section class="box">
      <div class="common-title">
        <div class="headTitle">
          <div class="imgIcon r"></div>
          <div class="title">多级别成长性课程体系</div>
          <div class="imgIcon l"></div>
        </div>
        <div class="smTitle">
          以6-12岁少儿的心理、认知、发展、成长等规律为基础，结合美术教育学科的五大核心要素
          专门为6-12岁国内少儿研发的一种全新形式的系统性AI数字美术绘画课程。
        </div>
      </div>
      <div class="box2-img commonStyle">
        <img
          alt=""
          :src="$common.getResourceUrl('pcweb/children/img_d1.png')"
          style="width: 100%"
        />
      </div>
    </section>
    <section class="box fff p0">
      <div class="common-title">
        <div class="headTitle">
          <div class="imgIcon r yellow"></div>
          <div class="title">丰富有趣的学习内容</div>
          <div class="imgIcon l yellow"></div>
        </div>
        <div class="smTitle">不仅学美术技法，更要开阔眼界</div>
      </div>
      <div class="box3-list commonStyle">
        <div v-for="(item, i) in richList" :key="i" class="li">
          <div class="img"><img :src="item.img" /></div>
          <p>{{ item.title }}</p>
          <span>{{ item.type }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: '',
  // Swiper,
  components: {},
  props: {},

  data() {
    return {
      richList: [
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_1.png'),
          title: '认识180+种',
          type: '动物植物',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_2.png'),
          title: '感受80+个',
          type: '国家文化',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_3.png'),
          title: '认识60+种',
          type: '民族服饰',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_4.png'),
          title: '领略100+种',
          type: '饮食风俗',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_5.png'),
          title: '观察80+座',
          type: '著名建筑',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_6.png'),
          title: '欣赏170+处',
          type: '美丽风景',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_7.png'),
          title: '走进100+位',
          type: '艺术大师',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_8.png'),
          title: '对话170+个',
          type: '卡通人物',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_9.png'),
          title: '掌握70+种',
          type: '绘画技巧',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_10.png'),
          title: '学习80+种',
          type: '人文自然',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_11.png'),
          title: '了解20+个',
          type: '节日主题',
        },
        {
          img: this.$common.getResourceUrl('pcweb/children/rich/rich_12.png'),
          title: '创350+幅',
          type: '美术作品',
        },
      ],
    }
  },
  computed: {
    scrollTop() {
      return this.$root.$children[0].scrollTop
    },
    pageBarHeight() {
      return this.$refs.pageBar ? parseInt(this.$refs.pageBar.barHeight) : 0
    },
    pageBarBg() {
      return this.scrollTop > this.pageBarHeight ? '#fff' : ''
    },
    pageBarLogoBg() {
      return this.scrollTop > this.pageBarHeight ? '' : '#fff'
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
section {
  width: 100%;
  min-width: 1200px;
}
.commonStyle {
  width: 1200px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}
.top-img {
  height: 620px;
  img {
    object-fit: cover;
  }
}
.fff {
  background-color: #fff;
}
.p0 {
  padding-bottom: 0 !important;
}
.bg {
  padding: 120px 0 203px !important;
  background-color: skyblue;
}
// 公共标题部分
.common-title {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.headTitle {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  margin-bottom: 15px;
  .title {
    font-size: 30px;
    color: #000000;
    margin: 0 15px;
    font-weight: 700;
  }
  .yellow::after,
  .yellow::before {
    content: '';
    background-image: linear-gradient(
      90deg,
      transparent 0%,
      #f3c37d 100%
    ) !important;
  }
  .imgIcon {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.l {
      transform: rotateY(180deg);
    }
    &.r {
      transform: rotateY(0);
    }
    &::before {
      content: '';
      width: 38px;
      height: 4px;
      background-image: linear-gradient(90deg, transparent 0%, #16bcf8 100%);
      margin-bottom: 5px;
      border-radius: 10px;
    }

    &::after {
      content: '';
      width: 38px;
      height: 7px;
      background-image: linear-gradient(90deg, transparent 0%, #16bcf8 100%);
      border-top-right-radius: 4px;
    }
  }
}
.smTitle {
  display: flex;
  justify-content: center;
  width: 960px;
  padding: 0 100px;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 80px;
  font-size: 20px;
  line-height: 35px;
  letter-spacing: -1px;
  color: #828282;
}
.box {
  padding-bottom: 100px;
  .box1-img {
    display: flex;
    justify-content: space-between;
    height: 450px;
    .childrenImg {
      width: 270px;
      height: 420px;
      border-radius: 8px;
      overflow: hidden;

      position: relative;
      span {
        position: absolute;
        bottom: 30px;
        left: 20px;
        font-size: 25px;
        color: #fff;
      }
      img {
        object-fit: cover;
      }

      &:nth-child(2),
      &:nth-child(4) {
        margin-top: 30px;
      }

      transition: all 0.4s ease-out;
      &:hover {
        transform: scale(1.06);
      }
    }
  }
  .box3-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 40px;
    .li {
      width: 170px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 60px;
      transition: all 0.4s ease-out;
      &:hover {
        transform: scale(1.1);
      }
      .img {
        width: 100px;
        height: 100px;
        // border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      p {
        font-size: 18px;
        line-height: 23px;
        color: #000000;
        margin: 20px 0 8px;
      }
      span {
        font-size: 16px;
        line-height: 23px;
        color: #777777;
      }
    }
  }
  .img-text {
    padding-top: 100px;

    .text {
      display: flex;
      justify-content: space-between;
      margin-bottom: 70px;
      .text1 {
        width: 231px;
        p {
          font-size: 32px;
          letter-spacing: 1px;
          color: #272c38;
        }
      }
      .text2 {
        width: 600px;
        p {
          font-size: 20px;
          line-height: 30px;
          letter-spacing: -1px;
          color: #777777;
        }
      }
    }
    .img {
      height: 560px;
      border-radius: 15px;
      background-color: powderblue;
    }
  }
  .box4-swp {
    .swp-title {
      margin-bottom: 10px;
      h4 {
        font-size: 32px;
        font-weight: normal;
        letter-spacing: 1px;
        color: #ffffff;
        margin-bottom: 10px;
      }
      p {
        font-size: 21px;
        color: #ffffff;
      }
    }
    .swp {
      height: 400px;
      background-color: #fff;
    }
  }
}
.subject {
  .subject-box {
    display: flex;
    padding: 80px 0;
    .subject-img {
      width: 400px;
      height: 260px;
      margin-right: 50px;
      background-color: #d8d8d8;
      border-radius: 10px;
      overflow: hidden;
    }
    .subject-content {
      h3 {
        font-size: 32px;
        color: #272c38;
        margin-bottom: 10px;
      }
      p {
        font-size: 18px;
        color: #828282;
      }
      .baoming {
        display: flex;
        padding-top: 47px;
        .erweima {
          margin-right: 50px;
          img {
            width: 100px;
            height: 100px;
            margin-bottom: 9px;
          }
          p {
            text-align: center;
            font-size: 15px;
            letter-spacing: 2px;
            color: #828282;
          }
        }

        .money {
          display: flex;
          flex-direction: column;
          padding-top: 50px;
          .youhui-icon {
            width: 70px;
            border-radius: 10px 0 10px 0;
            text-align: center;
            padding: 3px 2px;
            margin-bottom: 5px;
            font-size: 15px;
            letter-spacing: -1px;
            color: #fa6400;
            background-color: rgba(250, 100, 0, 0.2);
          }
          .num {
            font-size: 40px;
            color: #fa6400;
            i {
              font-style: normal;
              font-size: 24px;
            }
            span {
              margin-left: 8px;
              text-decoration: line-through;
              font-size: 18px;
              letter-spacing: -1px;
              color: #828282;
            }
          }
        }
      }
    }
  }
}
</style>
